import { createFileRoute } from "@tanstack/react-router";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { ScanLine, Server, Database } from "lucide-react";
import { useQuery } from "@tanstack/react-query";
import { apiFetch } from "@/lib/api-client";
import { z } from "zod";

export const Route = createFileRoute("/radiology/")({
  component: Radiology,
});

function Stat({ label, value, loading, icon: Icon, color }: { label: string; value?: string | number; loading?: boolean; icon: any; color: string }) {
  return (
    <Card>
      <CardContent className="p-4">
        <div className="flex items-center justify-between">
          <span className="text-xs uppercase text-muted-foreground">{label}</span>
          <Icon className={`h-4 w-4 ${color}`} />
        </div>
        <div className="mt-2 text-2xl font-bold">{loading ? "..." : (value ?? "—")}</div>
      </CardContent>
    </Card>
  );
}

function Radiology() {
  const orthancQ = useQuery({
    queryKey: ["orthanc-stats"],
    queryFn: () => apiFetch("/api/imaging/orthanc/stats", { schema: z.any() }).catch(() => null),
  });
  const dcm4cheeQ = useQuery({
    queryKey: ["dcm4chee-stats"],
    queryFn: () => apiFetch("/api/imaging/dcm4chee/stats", { schema: z.any() }).catch(() => null),
  });

  return (
    <div className="space-y-4 p-6">
      <div>
        <h1 className="text-2xl font-bold tracking-tight flex items-center gap-2">
          <ScanLine className="h-5 w-5" /> Imagerie PACS
        </h1>
        <p className="mt-1 text-sm text-muted-foreground">Orthanc + dcm4chee + passerelle DICOM</p>
      </div>
      <div className="grid grid-cols-2 gap-3 md:grid-cols-4">
        <Stat label="PACS Orthanc" icon={Server} color="text-blue-400" loading={orthancQ.isLoading} value={orthancQ.data?.studies ?? "—"} />
        <Stat label="DCM4CHEE" icon={Database} color="text-purple-400" loading={dcm4cheeQ.isLoading} value={dcm4cheeQ.data?.studies ?? "—"} />
      </div>
      <Card>
        <CardHeader>
          <CardTitle>Modules DICOM</CardTitle>
          <CardDescription>Worklist, storage, retrieve, Q/R</CardDescription>
        </CardHeader>
        <CardContent className="text-sm text-muted-foreground">
          Worklist MWL · Storage SCU · Q/R SCP · MPPS · DICOMDIR · IHE-XDS-I.b
        </CardContent>
      </Card>
    </div>
  );
}
